import useErrorHandler from '@beeldit/core/errors/useErrorHandler';
import index from '@beeldit/core/services';
import { useContext } from 'react';
import { ProjectContext } from '../contexts/ProjectContext';

function useIndex() {    
    const {tableFilters, paginationConfig, orderBy, setTableData, setBackendFormErrors} = useContext(ProjectContext);   
    const errorHandler = useErrorHandler();
    return () => {
      let filterPath = '';
      if (tableFilters) {
        for (const [key, value] of Object.entries(tableFilters)) {
          if(value) {
            filterPath += `&${key}=${value}`;
          }              
        }
      }
      if (paginationConfig) {
        for (const [key, value] of Object.entries(paginationConfig)) {
          if(value && key !== 'total_items') {
            filterPath += `&${key}=${value}`;
          }              
        }
      }
      if(orderBy) {
        filterPath += `&orderBy=${orderBy}`;
      }
      index('projects', filterPath)
        .then((response: any) => {
          setTableData(response.data);
        })
        .catch((error: any) => {
          errorHandler(error, setBackendFormErrors)
        });
    }
  }
  
  export default useIndex;